import {} from "../baseStyles";

const homeStyle = (theme) => ({
	appBar: {
		position: "relative",
	},
	icon: {
		marginRight: theme.spacing(2),
	},
	heroUnit: {
		backgroundColor: "transparent",
	},
	heroContent: {
		maxWidth: 600,
		margin: "0 auto",
		padding: `${theme.spacing(8)}px 0 ${theme.spacing(6)}px`,
	},
	heroButtons: {
		marginTop: theme.spacing(4),
	},
	layout: {
		width: "auto",
		marginLeft: theme.spacing(3),
		marginRight: theme.spacing(3),
		[theme.breakpoints.up(1100 + theme.spacing(3) * 2)]: {
			width: 1100,
			marginLeft: "auto",
			marginRight: "auto",
		},
	},
	cardGrid: {
		padding: `${theme.spacing(8)}px 0`,
	},
	card: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
	},
	cardMedia: {
		paddingTop: "56.25%", // 16:9
	},
	cardContent: {
		flexGrow: 1,
	},
	footer: {
		backgroundColor: "transparent",
		padding: theme.spacing(6),
	},
});
export default homeStyle;
